import { call, put, takeLatest } from "redux-saga/effects";
import {
  LOYALTY_CLAIM_GO_BUTTON_ACTION,
} from "./actionType";

import {
  Loyalty_Claim_GoButton_Success,
  Loyalty_Claim_ApiErrorAction,
} from "./action";

import { LoyaltyClaimReportAPI } from "../../../helpers/backend_helper";

function* Loyalty_Claim_GenFunc({ config }) {
  try {
    // 🔹 Call API
    let response = yield call(LoyaltyClaimReportAPI, config);

    // 🔹 Safely handle missing or invalid data
    const data = Array.isArray(response.Data) ? response.Data : [];

    // 🔹 Format numeric fields (like PointsRedeemed, TotalRedemptionAmount)
    const formattedData = data.map((item) => {
      const formattedItem = { ...item };
      for (const key in formattedItem) {
        if (
          !isNaN(formattedItem[key]) &&
          formattedItem[key] !== null &&
          formattedItem[key] !== ""
        ) {
          formattedItem[key] = Number(formattedItem[key]).toFixed(2);
        }
      }
      return formattedItem;
    });

    // 🔹 Attach formatted data and btnId
    response["Data"] = formattedData;
    response["Type"] = config.btnId;

    // 🔹 Dispatch success
    yield put(Loyalty_Claim_GoButton_Success(response));

  } catch (error) {
    console.error("❌ Loyalty Claim Saga Error:", error);
    yield put(Loyalty_Claim_ApiErrorAction());
  }
}

// 🧩 Root Saga
export default function* Loyalty_Claim_Saga() {
  yield takeLatest(LOYALTY_CLAIM_GO_BUTTON_ACTION, Loyalty_Claim_GenFunc);
}
